export function rootCtx(session) {
    return { aliases: session.aliases };
}
export function nameOrHashRef(text) {
    if (text.startsWith('#')) {
        return { kind: 'hash', prefix: text.slice(1), span: { start: 0, end: text.length, line: 1, column: 1 } };
    }
    return { kind: 'name', text, parts: text.split('.'), span: { start: 0, end: text.length, line: 1, column: 1 } };
}
